<template>
  <v-container class="pa-0">
    <v-dialog  class="pa-0 display-unset" v-model="dialog" width="500">
      <v-btn icon @click="save" slot="activator"> <v-icon class="select-pack-color left blue-grey--text">delete</v-icon></v-btn>
      <div center class="text-xs-center">
        <v-avatar color="primary" size="125" >
          <v-icon dark class="f-130">info</v-icon>
        </v-avatar>
        <v-icon class="mb-5"></v-icon>
      </div>
      <v-card class="card-pop card-r no-shadow pa-3">
        <div  class="pt-3 mt-5 text-xs-center">
         <span class="f-20">
            Are you sure Want to delete this <br> Package?
         </span>
        </div>
        <v-layout>
          <v-flex>
            <v-flex xs12 class="pt-2">
              <v-list>

                <v-card color="grey lighten-2" class="mt-2 mb-4 pt-3 pa-2 mb-2 card-r no-shadow">
                  <v-list-tile>
                    <v-list-tile-action>
                      <!--<v-icon color="primary" class="f-30">fas fa-check-circle</v-icon>-->
                      <v-icon color="primary" class="f-30">info</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>Package Name</v-list-tile-title>
                    </v-list-tile-content>

                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-action>
                      <!--<v-icon color="primary" class="f-30">fas fa-check-circle</v-icon>-->
                      <v-icon color="primary" class="f-30">info</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>description</v-list-tile-title>
                    </v-list-tile-content>

                  </v-list-tile>
                </v-card>
                <!--<v-card color="grey lighten-2" class="mb-4 pt-3 pa-2 card-r no-shadow">-->
                  <!--<v-list-tile>-->
                    <!--<v-list-tile-action>-->
                      <!--&lt;!&ndash;<v-icon color="primary" class="f-30">fas fa-check-circle</v-icon>&ndash;&gt;-->
                      <!--<v-icon color="primary" class="f-30">info</v-icon>-->
                    <!--</v-list-tile-action>-->

                    <!--<v-list-tile-content>-->
                      <!--<v-list-tile-title>Part of 3 Packages </v-list-tile-title>-->
                    <!--</v-list-tile-content>-->

                  <!--</v-list-tile>-->
                <!--</v-card>-->
              </v-list>
              <!--<v-flex md12 sm12 xs12 class=" checkbox  mt-2">-->
              <!--<v-checkbox-->
              <!--v-model="policy"-->
              <!--label="Same The Profile Info"-->
              <!--class="input-group&#45;&#45;focused f-20 pa-0 ma-0"-->
              <!--color="primary"-->
              <!--required-->
              <!--&gt;</v-checkbox>-->
              <!--</v-flex>-->
            </v-flex>
            <v-layout xs12>
              <v-flex xs12 class="text-xs-left mr-1">
                <v-btn @click="dialog = false" color="grey lighten-2" class="btn-customer card-r">Cancel</v-btn>
              </v-flex>
              <v-flex xs12 class="text-xs-right ml-1">
                <v-btn @click="dialog = false" to="/packages"  class="btn-customer card-r primary text-white no-shadow card-r">Delete</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  export default {
    data () {
      return {
        dialog: false
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem
  .card-pop{
    z-index: -4;
    margin-top: -12%;
  }
  .v-dialog{
    box-shadow: none!important;
  }
  .btn-customer{
    margin: 6px 0px 6px 0px !important;
    height: 45px;
    width: 100%;
  }
  .text-white{
    color: #ffffff!important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/pages/package/ConfirmDelete.vue